import React from 'react';

const AppContext = React.createContext({
    currentUser: null,
    settings: null,
    canView: () => {},
    canChange: () => {},
    updateUserData: () => {},
});

function createListener() {
    let state = [];
    const listeners = new Set();
    const add = listener => {
        listeners.add(listener);
        listener(...state);
        return () => listeners.delete(listener);
    };
    add.notify = (...args) => {
        state = args;
        for (const listener of listeners) {
            listener(...state);
        }
    };
    return add;
}

const on = {
    background: createListener(),
    scroll: createListener(),
};

AppContext.create = (user, settings, updateUserData) => ({
    on,
    currentUser: user,
    settings,
    canView: component => user.canView(component),
    canChange: component => user.canChange(component),
    updateUserData: updateUserData,
});

const withAppContext = Component => {
    return function WrapperComponent(props) {
        return (
            <AppContext.Consumer>
                {app => <Component {...props} app={app} />}
            </AppContext.Consumer>
        );
    };
};

export { AppContext, withAppContext };
